{
  "open": "Chat openen",
  "unread_one": "{count} ongelezen bericht",
  "unread_other": "{count} ongelezen berichten",
  "close": "Sluiten"
}
